// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-vlight":"#f6f6f6","grey-light":"#c9c9c9"};